import { Typography } from 'components/Typography'

import { Tooltip } from 'components/Tooltip'
import { X } from 'react-feather'
import AchieveLogoSVGBlack from 'components/Svgs/AchieveLogoSVGBlack'

import { FloatingBadge } from 'components/DebtAssessment/FloatingBadge'
import AchieveRLogoSVG from 'components/Svgs/AchieveRLogoSVG'
import Ok from 'components/Svgs/Ok'

export const DatTable = ({
  firstColumnLabel = 'Current',
  lastColumnLabel = 'Est. Savings',
  labelFirstRow = 'Est. monthly payment',
  labelSecondRow = 'Est. total debt cost',
  tooltipLabelSecondRow = 'Your starting debt amount and added interest built up over time',
  monthlyCurrent = '$750',
  monthlyAchieve = '$540',
  monthlySavings = '$210',
  totalCurrent = '$53,000',
  totalAchieve = '$20,000',
  totalSavings = '$33,000',
  badge = true,
  estSavingsColumn = true,
  estMonthlySavingsBottom = true,
  variation = 'line',
  labelThirdRow,
  labelFirstRowSup,
  labelSecondRowSup,
  labelThirdRowSup,
  currentTime = '27 yr',
  achieveTime = '2-4 yr',
}) => {
  return variation == 'bars' ? (
    <div className="max-w-md mx-auto rounded-3xl overflow-hidden border-[#DFE5EB] border-solid border-2">
      <table className="w-full border-collapse">
        <thead>
          <tr className="border-b-2 border-[#DFE5EB]">
            <th className="p-4 w-1/3">{''}</th>
            <th className="p-4 w-1/3" data-testid="first-column-label">
              <div className="flex items-center justify-center">
                <AchieveRLogoSVG title="Achieve Logo" alt="Achieve Logo" height="20" width="80" />
              </div>
            </th>
            <th className="p-4 w-1/3">
              <Typography
                variant="labelMd"
                mobilevarian="labelSm"
                data-testid="second-column-label"
              >
                {firstColumnLabel}
              </Typography>
            </th>
          </tr>
        </thead>
        <tbody>
          <tr className="border-[#DFE5EB] border-b-2 border-t-2 border border-solid border-r-0 border-l-0 ">
            <td className="p-4 text-gray-600">
              <div>
                <Typography
                  variant="labelSm"
                  className="text-gray-500"
                  data-testid="first-row-label-one"
                >
                  {labelFirstRow}
                  {labelFirstRowSup && <sup>{labelFirstRowSup}</sup>}
                </Typography>
              </div>
            </td>
            <td className="p-4 bg-blue-50 text-left">
              <Typography
                data-testid="first-row-label-two"
                variant="labelSm"
                className="flex items-center justify-between w-full text-[#154199]"
              >
                {monthlyAchieve}/mo
                <Ok className="h-5 w-5 " />
              </Typography>
            </td>
            <td className="p-4 text-center text-gray-800" data-testid="first-row-label-three">
              <Typography variant="labelSm">{monthlyCurrent}/mo</Typography>
            </td>
          </tr>
          <tr className="border-[#DFE5EB] border-b-2 border border-solid border-r-0 border-l-0 border-t-0 ">
            <td className="p-4 text-gray-600">
              <div>
                <Typography
                  variant="labelSm"
                  className="text-gray-500"
                  data-testid="second-row-label-one"
                >
                  {labelSecondRow}
                  {labelSecondRowSup && <sup>{labelSecondRowSup}</sup>}
                </Typography>
              </div>
            </td>
            <td className="p-4 bg-blue-50 text-left">
              <Typography
                data-testid="second-row-label-two"
                variant="labelSm"
                className="flex items-center justify-between w-full text-[#154199]"
              >
                {achieveTime}
                <Ok className="h-5 w-5 " />
              </Typography>
            </td>
            <td className="p-4 text-center text-gray-800">
              <Typography variant="labelSm" data-testid="second-row-label-three">
                {currentTime}
              </Typography>
            </td>
          </tr>

          <tr>
            <td className="p-4 text-gray-600">
              <div>
                <Typography
                  variant="labelSm"
                  className="text-gray-500"
                  data-testid="third-row-label-one"
                >
                  {labelThirdRow}
                  {labelThirdRowSup && <sup>{labelThirdRowSup}</sup>}
                </Typography>
              </div>
            </td>
            <td className="p-4 bg-blue-50 text-left">
              <Typography
                data-testid="third-row-label-two"
                variant="labelSm"
                className="flex items-center justify-between w-full text-[#154199]"
              >
                {totalAchieve}
                <Ok className="h-5 w-5" />
              </Typography>
            </td>
            <td className="p-4 text-center text-gray-800">
              <Typography variant="labelSm" data-testid="third-row-label-three">
                {totalCurrent}
              </Typography>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  ) : (
    <table className="border-collapse w-full">
      <tbody>
        <tr className="flex flex-wrap w-full text-center">
          <td className="flex flex-col flex-1 h-[30px] p-0" />
          <th className="flex flex-col flex-1 h-[30px]  rounded-tl-lg lg:rounded-none p-0 bg-[rgb(248,249,252)]">
            <div className="h-full border-l border-[rgb(51,0,255)] flex items-center justify-center">
              <Typography
                variant="bodyXs"
                fontWeight="medium"
                className="text-gray-500"
                data-testid="first-column-label"
              >
                {firstColumnLabel}
              </Typography>
            </div>
          </th>
          <th className="flex flex-col flex-1 h-[30px] bg-[rgb(51,0,255)] justify-center items-center p-0">
            <div
              className="h-full flex justify-center items-center border-l border-r border-blue-200"
              data-testid="second-column-label"
            >
              <AchieveLogoSVGBlack />
            </div>
          </th>
          {estSavingsColumn && (
            <th
              className="relative flex flex-col flex-1 h-[30px] bg-green-300 justify-center items-center p-0"
              data-testid="third-column-label"
            >
              {badge && (
                <div className="absolute -top-3 -right-3">
                  <FloatingBadge />
                </div>
              )}
              <Typography
                variant="bodyXs"
                fontWeight="medium"
                className="text-white"
                data-testid="third-column-label"
              >
                {lastColumnLabel}
              </Typography>
            </th>
          )}
        </tr>
        <tr className="flex flex-wrap w-full text-center">
          <th className="flex flex-col flex-1 h-[50px] lg:h-[95px] bg-white p-0 place-content-center">
            <div className="flex justify-center items-center text-right lg:text-left w-full">
              <Typography
                variant="bodyXs"
                className="text-gray-500"
                data-testid="first-row-label-one"
              >
                {labelFirstRow}
                {labelFirstRowSup && <sup>{labelFirstRowSup}</sup>}
              </Typography>
            </div>
          </th>
          <td className="flex flex-col flex-1 h-[50px] lg:h-[95px] bg-white border-t  border-r-0 border-b-0 border-solid lg:border-l border-gray-300 p-0">
            <div className="flex justify-center items-center h-full">
              <Typography variant="bodySm" fontWeight="bold" data-testid="first-row-label-two">
                {monthlyCurrent}
              </Typography>
            </div>
          </td>
          <td className="flex flex-col flex-1 h-[50px] lg:h-[95px] bg-white border-t border-l  border-r-0 border-b-0 border-solid border-gray-300 p-0">
            <div className="flex justify-center items-center h-full">
              <Typography variant="bodySm" fontWeight="bold" data-testid="first-row-label-three">
                {monthlyAchieve}
              </Typography>
            </div>
          </td>
          {estSavingsColumn && (
            <td className="flex flex-col flex-1 h-[50px] lg:h-[95px] bg-green-100 border-l border-t border-gray-300 p-0">
              <div className="flex justify-center items-center h-full">
                <Typography
                  variant="bodySm"
                  fontWeight="bold"
                  className="text-green-500"
                  data-testid="first-row-label-four"
                >
                  {monthlySavings}
                </Typography>
              </div>
            </td>
          )}
        </tr>
        <tr className="flex flex-wrap w-full text-center">
          <th className="flex flex-col flex-1 h-[50px] lg:h-[95px] bg-white border-t p-0 place-content-center">
            <div className="flex justify-center items-center text-right lg:text-left w-full">
              {tooltipLabelSecondRow ? (
                <div className="text-gray-500 text-left">
                  <Tooltip
                    title={
                      <div className="flex flex-row-reverse justify-between items-start gap-2">
                        <span>
                          <X className="text-gray-400 cursor-pointer w-6 h-6 -translate-y-2 hover:text-gray-300" />
                        </span>
                        <span>
                          {labelSecondRow && (
                            <span className="flex">
                              <Typography variant="labelSm" fontWeight="bold" className="mb-1">
                                {labelSecondRow}
                              </Typography>
                            </span>
                          )}
                          {tooltipLabelSecondRow && (
                            <span>
                              <Typography component="div" variant="bodyXs">
                                {tooltipLabelSecondRow}
                              </Typography>
                            </span>
                          )}
                        </span>
                      </div>
                    }
                    width={300}
                  >
                    {labelSecondRow} {labelSecondRowSup && <sup>{labelSecondRowSup}</sup>}
                  </Tooltip>
                </div>
              ) : (
                <Typography
                  variant="bodyXs"
                  className="text-gray-500"
                  data-testid="second-row-label-one"
                >
                  {labelSecondRow} {labelSecondRowSup && <sup>{labelSecondRowSup}</sup>}
                </Typography>
              )}
            </div>
          </th>
          <td className="flex flex-col flex-1 h-[50px] lg:h-[95px] bg-white border-t border-r-0 border-b-0 border-solid lg:border-l border-gray-300 p-0">
            <div className="flex justify-center items-center h-full">
              <Typography variant="bodySm" fontWeight="bold" data-testid="second-row-label-two">
                {totalCurrent}
              </Typography>
            </div>
          </td>
          <td className="flex flex-col flex-1 h-[50px] lg:h-[95px] bg-white border-t border-l  border-r-0 border-b-0 border-solid border-gray-300 p-0">
            <div className="flex justify-center items-center h-full">
              <Typography variant="bodySm" fontWeight="bold" data-testid="second-row-label-three">
                {totalAchieve}
              </Typography>
            </div>
          </td>
          {estSavingsColumn && (
            <td className="flex flex-col flex-1 h-[50px] lg:h-[95px] bg-green-100 border-l border-t border-gray-300 p-0">
              <div className="flex justify-center items-center h-full">
                <Typography
                  variant="bodySm"
                  fontWeight="bold"
                  className="text-green-500"
                  data-testid="second-row-label-four"
                >
                  {totalSavings}
                </Typography>
              </div>
            </td>
          )}
        </tr>

        {estMonthlySavingsBottom && (
          <tr>
            <td colSpan={4} className="bg-green-300 h-[50px] lg:h-[95px] flex place-content-center">
              <div className="flex items-center gap-2 px-2">
                {badge && <FloatingBadge />}
                <Typography
                  variant="bodySm"
                  fontWeight="regular"
                  className="text-white text-sm"
                  data-testid="estimated-savings"
                >
                  Your estimated savings could be <strong>{monthlySavings}/month</strong>
                </Typography>
              </div>
            </td>
          </tr>
        )}
      </tbody>
    </table>
  )
}
